import {importLibrary, setOptions} from "@googlemaps/js-api-loader";
import {useEffect, useState} from "react";

export function useGoogleMaps() {
    const [mapLoaded, setMapLoaded] = useState(false);

    useEffect(() => {
        if (!(window as any).__GOOGLE_MAPS_OPTIONS_SET__) {
            setOptions({
                key: appConfig.googleMapsKey,
                libraries: ["geometry", "marker"],
            });
            (window as any).__GOOGLE_MAPS_OPTIONS_SET__ = true;
        }

        importLibrary("maps").then(() => setMapLoaded(true));
    }, []);

    return mapLoaded;
}
